import React from 'react';
import './certificats.css'

function C2wOfflineCertificates({ courseTitle }) {
  return (
    <div className='C2wOfflineCertificates_ctn'>
      <div className='C2wOfflineCertificates_heading'>
        <span>Get certificates </span>
        {'after completing the course'}
      </div>
      {courseTitle === "Python Data Science GenAI with IoT & Robotics" ? (
        <div className='C2wOfflineCertificates_holders'>
          <img src="/assets/images/offlineCourseDetail/Python.png" alt='certificates' />
          <img src="/assets/images/offlineCourseDetail/Data.png" alt='certificates' />
          <img src="/assets/images/offlineCourseDetail/GenAI.png" alt='certificates' />
          <img src="/assets/images/offlineCourseDetail/IoT.png" alt='certificates' />
          <img src="/assets/images/offlineCourseDetail/Robotics.png" alt='certificates' />
          <img src="/assets/images/offlineCourseDetail/Superx-python.png" alt='certificates' />
        </div>
      ) : (

        <div className='C2wOfflineCertificates_holders'>
          <img src="/assets/images/offlineCourseDetail/Java.png" alt='certificates' />
          <img src="/assets/images/offlineCourseDetail/Dsa.png" alt='certificates' />
          <img src="/assets/images/offlineCourseDetail/Dbms.png" alt='certificates' />
          <img src="/assets/images/offlineCourseDetail/Os.png" alt='certificates' />
          <img src="/assets/images/offlineCourseDetail/Superx-java.png" alt='certificates' />
        </div>
      )}
    </div>
  )
}

export default C2wOfflineCertificates
